/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO para una fila del \"Box Score\" (estadísticas de jugador en un partido).
 */
export interface MatchPlayerStatsDetailsDTO { 
    player_id: string;
    player_name: string;
    team_id: string;
    dorsal?: number | null;
    goals?: number | null;
    exclusions?: number | null;
}

